import { ACTION_TYPES } from "./helpers";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitSyncRoom = () => {
  const localParticipant = useLivekitLocalParticipant();

  return () => {
    if (!localParticipant) {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Updating typescript-eslint, should be fixed when appropriate
      return Promise.reject("localParticipant is not present");
    }
    const encoder = new TextEncoder();
    const action = JSON.stringify({
      type: ACTION_TYPES.UPDATE_ROOM,
    });

    return localParticipant.publishData(encoder.encode(action), {
      reliable: true,
    });
  };
};
